module.exports = __webpack_public_path__ + "media/images/wedding/top/hall-list/plan-wedding-lineup-kanto-4-4ae5c7af066fc7244b369996939c2ed4.png";